export const loadPreferences = () => ({
  type: "LOAD_PREFERENCES_REQUEST",
});

export const updatePreferences = data => ({
  type: "UPDATE_PREFERENCES_REQUEST",
  data,
});



// WEBPACK FOOTER //
// ./src/scenes/PreferencesPage/actions.js